import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { SplitButton } from 'primereact/splitbutton';
import { MenuItem } from 'primereact/menuitem';

import { ConfirmDialogService, FormatDisplay, ToastService, useForm } from '@iamsoftware/react-hooks';
import { DocumentSignService } from "../../service/DocumentSignService";
import { AgreementService, AgreementService as Service } from 'src/service/AgreementService';
import { AppStorage } from '../../service/UserStorage';
import { Oauth2GoogleService } from '../../app/hop-dong/mau-hop-dong/Oauth2GoogleService';
import { AuthService } from '../../service/AuthService';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { ScrollPanel } from 'primereact/scrollpanel';
import { SignatureSelectorDialog } from './components/SignatureSelectorDialog';

GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.mjs';

export const Detail = ({ display, setDisplay, setRefresh, signingSecretCode, setSigningSecretCode }) => {
  const [data, setData] = useState(null)
  const [headerInfo, setHeaderInfo] = useState(null)
  const [displayDetail, setDisplayDetail] = useState(false)
  const [displayCode, setDisplayCode] = useState(null)
  const [reload, setReload] = useState(null)
  const [mainFiles, setMainFiles] = useState([])
  const [attachmentFiles, setAttachmentFiles] = useState([])
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [viewingAttachmentIndex, setViewingAttachmentIndex] = useState(null)
  const openedFileIdsRef = useRef<Set<string>>(new Set())
  const [mainFileReady, setMainFileReady] = useState<{ [key: string]: boolean }>({})
  const [attachmentFileReady, setAttachmentFileReady] = useState<{ [key: string]: boolean }>({})
  const [openingFileIds, setOpeningFileIds] = useState<Set<string>>(new Set())
  const [mainFileBlobUrls, setMainFileBlobUrls] = useState<{ [key: string]: string }>({})
  const [attachmentFileBlobUrls, setAttachmentFileBlobUrls] = useState<{ [key: string]: string }>({})
  const mainFileBlobUrlsRef = useRef<{ [key: string]: string }>({})
  const attachmentFileBlobUrlsRef = useRef<{ [key: string]: string }>({})

  const [mainFileCanvases, setMainFileCanvases] = useState<{ [key: string]: HTMLCanvasElement[] }>({})
  const [attachmentFileCanvases, setAttachmentFileCanvases] = useState<{ [key: string]: HTMLCanvasElement[] }>({})
  const [canvasLoading, setCanvasLoading] = useState<boolean>(false)

  const [activeMainIndex, setActiveMainIndex] = useState(0)
  const [activeAttachmentIndex, setActiveAttachmentIndex] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  const [visualDataMap, setVisualDataMap] = useState<{ [key: string]: string }>({})
  const [displaySignatureSelector, setDisplaySignatureSelector] = useState(false)
  const [selectingLocationId, setSelectingLocationId] = useState<string | null>(null)
  const [selectingExpectedType, setSelectingExpectedType] = useState<string | undefined>(undefined)

  const ensureToken = async () => {
    try {
      const res = await AuthService.getToken();
      if (res?.moquiSessionToken) {
        AppStorage.set('moquiSessionToken', res.moquiSessionToken);
      }
    } catch (e) {
      // ignore token errors, will rely on existing session if any
    }
  };
  useEffect(() => {
    if (display && display !== false && display !== 'false' && display !== null && display !== 'null') {
      // Reset files states when loading new data
      setMainFiles([]);
      setAttachmentFiles([]);
      setMainFileReady({});
      setAttachmentFileReady({});
      setMainFileCanvases({});
      setAttachmentFileCanvases({});
      setActiveMainIndex(0);
      setActiveAttachmentIndex(0);
      setCurrentPage(1);
      setActiveTabIndex(0);

      Service.getHeaderInfo(display).then(data => {
        console.log('Detail getHeaderInfo response:', data);
        setHeaderInfo(data);
        if (data?.agreementDate) {
          data.agreementDate = FormatDisplay.date(new Date(data.agreementDate), 'YYYY-MM-DD');
        }
        // Lưu danh sách files
        setMainFiles(data?.mainFiles || data?.agreementContents?.filter((f: any) => f.isMainFile === 'Y' || !f.isAttachment) || []);
        setAttachmentFiles(data?.attachmentFiles || data?.agreementContents?.filter((f: any) => f.isMainFile === 'N' || f.isAttachment) || []);
        infoForm.setValue(data);
      }).catch(error => {
        console.error('Error in getHeaderInfo:', error);
      });
      setData(display);
    }
  }, [display]);


  useEffect(() => {
    if (reload && display && display !== false && display !== 'false' && display !== null && display !== 'null') {
      Service.getHeaderInfo(display).then(data => {
        setHeaderInfo(data)
        if (data?.agreementDate) {
          data.agreementDate = FormatDisplay.date(new Date(data.agreementDate), 'YYYY-MM-DD');
        }
        // Lưu danh sách files
        setMainFiles(data?.mainFiles || data?.agreementContents?.filter((f: any) => f.isMainFile === 'Y' || !f.isAttachment) || []);
        setAttachmentFiles(data?.attachmentFiles || data?.agreementContents?.filter((f: any) => f.isMainFile === 'N' || f.isAttachment) || []);
        infoForm.setValue(data);
      }).catch(error => {
      })
    }
  }, [reload]);

  const agreementId = headerInfo?.agreementId || headerInfo?.id || data?.agreementId;

  const renderPage = (pdf: any, pageNumber: number) => {
    return pdf.getPage(pageNumber).then((page: any) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      return page.render(renderContext).promise.then(() => canvas);
    });
  };

  const loadPDFToCanvas = async (arrayBuffer: ArrayBuffer, cacheKey: string, type: 'main' | 'attachment') => {
    setCanvasLoading(true);
    try {
      const loadingTask = getDocument({ data: arrayBuffer });
      const pdf = await loadingTask.promise;
      const canvasPromises = [];
      for (let i = 1; i <= pdf.numPages; i++) {
        canvasPromises.push(renderPage(pdf, i));
      }
      const canvases = await Promise.all(canvasPromises);
      if (type === 'main') {
        setMainFileCanvases(prev => ({ ...prev, [cacheKey]: canvases }));
      } else {
        setAttachmentFileCanvases(prev => ({ ...prev, [cacheKey]: canvases }));
      }
    } catch (err) {
      console.error('Error rendering PDF to canvas:', err);
      ToastService.error('Lỗi khi hiển thị file');
    } finally {
      setCanvasLoading(false);
    }
  };

  const extractGoogleFileId = (file: any) => {
    if (file?.referenceFileId) return file.referenceFileId;
    if (file?.fileId) return file.fileId;
    if (file?.googleFileId) return file.googleFileId;
    
    // Extract from contentLocation if it's a Google Drive URL
    const location = file?.contentLocation || file?.googleFileUrl;
    if (location && typeof location === 'string') {
      const match = location.match(/\/d\/([a-zA-Z0-9_-]+)/);
      if (match && match[1]) return match[1];
    }
    
    return file?.agreementContentId || file?.id || file?.contentId || file?.description;
  };

  useEffect(() => {
    const loadActiveFile = async () => {
      const type = activeTabIndex === 0 ? 'main' : 'attachment';
      const files = activeTabIndex === 0 ? mainFiles : attachmentFiles;
      const index = activeTabIndex === 0 ? activeMainIndex : activeAttachmentIndex;
      const file = files[index];

      if (!file || !agreementId) return;

      const fileId = extractGoogleFileId(file);
      const cacheKey = `${type}_${fileId || index}`;

      // Check if already ready
      if (type === 'main' ? mainFileReady[cacheKey] : attachmentFileReady[cacheKey]) return;

      try {
        let arrayBuffer: ArrayBuffer | null = null;
        if (fileId) {
          await ensureToken();
          if (!openedFileIdsRef.current.has(fileId)) {
            await AgreementService.openContent(agreementId, fileId);
            openedFileIdsRef.current.add(fileId);
          }
          const blob = await AgreementService.downloadPdf(fileId);
          arrayBuffer = await blob.arrayBuffer();
        }

        if (arrayBuffer) {
          // Giải phóng bộ nhớ của các file khác trước khi load file mới (Lazy Load dọn dẹp)
          if (type === 'main') {
            setMainFileCanvases({});
            setMainFileReady({});
          } else {
            setAttachmentFileCanvases({});
            setAttachmentFileReady({});
          }

          await loadPDFToCanvas(arrayBuffer, cacheKey, type);
          
          if (type === 'main') {
            setMainFileReady({ [cacheKey]: true });
          } else {
            setAttachmentFileReady({ [cacheKey]: true });
          }
        }
      } catch (err) {
        console.error(`Error loading ${type} file:`, err);
        if (type === 'main') setMainFileReady({ [cacheKey]: true });
        else setAttachmentFileReady({ [cacheKey]: true });
      }
    };

    loadActiveFile();
  }, [activeTabIndex, activeMainIndex, activeAttachmentIndex, mainFiles, attachmentFiles, agreementId]);

  useEffect(() => {
    return () => {
      Object.values(mainFileBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url)
        }
      })
      Object.values(attachmentFileBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url)
        }
      })
    }
  }, [])


  const showDetail = () => {
    if (displayDetail === false) {
      setDisplayDetail(true)
    } else setDisplayDetail(false)
  }
  const signFile = async () => {
    if (headerInfo?.signatureLocationList) {
      const visualLocs = headerInfo.signatureLocationList.filter((l: any) => 
         l.signatureTypeEnumId === 'AgtHandwritingVerified' || l.signatureTypeEnumId === 'AgtImageVerified');
      const missing = visualLocs.find((l: any) => !visualDataMap[l.locationSeqId] && !l.visualData);
      if (missing) {
         ToastService.error(`Vui lòng chọn ảnh chữ ký cho vị trí: ${missing.name || 'chưa đặt tên'}`);
         return;
      }
    }

    if (signingSecretCode) {
      if (!data) {
        ToastService.error('Mã hợp đồng không hợp lệ. Vui lòng thử lại!');

        try {
          await Service.updateSigningError({
            referenceNumber: null,
            signingSecretCode: signingSecretCode,
            roleTypeId: headerInfo?.roleTypeId || 'PartyA'
          });
        } catch (apiError) {
        }

        return;
      }

      try {
        const signResult = await DocumentSignService.sign({
          referenceNumber: data,
          signingSecretCode: signingSecretCode,
          visualDataMap: visualDataMap
        });

        if (signResult?.success && signResult?.data) {
          const { signedAgreements, signedFiles, signedFilesBase64 } = signResult.data;
          const roleTypeId = signResult?.roleTypeId || 'PartyA';
          
          // Chuẩn bị danh sách file đã ký để đẩy về server
          let pushParams: any = {
            signedBy: 'BUYER',
            agreementId: signResult.agreementId || agreementId,
            roleTypeId: roleTypeId,
            referenceNumber: data,
            signingSecretCode: signingSecretCode,
            signedByName: signResult.data.signedByName || ''
          };

          if (signedAgreements && Array.isArray(signedAgreements) && signedAgreements.length > 0) {
            // Cấu trúc lồng nhau mới: Agent trả về signedAgreements -> files
            // Flatten thành mảng signedFiles phẳng kèm agreementContentId
            pushParams.signedFiles = signedAgreements.flatMap((ag: any) =>
              (ag.files || []).map((f: any) => ({
                agreementContentId: f.agreementContentId,
                base64FileData: f.base64FileData
              }))
            );
          } else if (signedFiles && Array.isArray(signedFiles) && signedFiles.length > 0) {
            // Tương thích ngược: Agent trả về array signedFiles phẳng kèm agreementContentId
            pushParams.signedFiles = signedFiles.map((sf: any) => ({
              agreementContentId: sf.agreementContentId,
              base64FileData: sf.base64FileData
            }));
          } else if (signedFilesBase64 && Array.isArray(signedFilesBase64) && signedFilesBase64.length > 0) {
            // Tương thích ngược cũ: Agent trả về array string base64
            pushParams.base64FileData = signedFilesBase64[0];
          }

          try {
            await Service.pushSignedData(pushParams);

            setRefresh(Date.now());
            setDisplay(false);
            AppStorage.set('reload', String(Date.now()));
            setReload(Date.now());
            ToastService.success('Ký hợp đồng thành công!');
          } catch (pushError) {
            console.error('Error pushing signed data:', pushError);
            const errMsg = pushError?.response?.data?.errors || 'Lỗi khi lưu file đã ký về server';
            ToastService.error(errMsg);
            
            try {
              await Service.updateSigningError({
                referenceNumber: data,
                signingSecretCode: signingSecretCode,
                roleTypeId: roleTypeId
              });
            } catch (apiError) {
            }
          }
        } else {
            // Xử lý khi Agent báo lỗi hoặc không có dữ liệu trả về
            const roleTypeId = signResult?.roleTypeId || headerInfo?.roleTypeId || 'PartyA';
            try {
              await Service.updateSigningError({
                referenceNumber: data,
                signingSecretCode: signingSecretCode,
                roleTypeId: roleTypeId
              });
            } catch (apiError) {
            }
            if (signResult?.errorMessage) {
               ToastService.error(signResult.errorMessage);
            }
        }
      } catch (error) {
        console.error('Error in signFile process:', error);
        try {
          await Service.updateSigningError({
            referenceNumber: data,
            signingSecretCode: signingSecretCode,
            roleTypeId: headerInfo?.roleTypeId || 'PartyA'
          });
        } catch (apiError) {
        }
        if (error?.response?.status === 400 || error?.message?.includes('pull-data') || error?.config?.url?.includes('pull-data')) {
          ToastService.error('Lỗi khi tải dữ liệu ký số. Vui lòng thử lại!');
        } else {
          ToastService.error('Có lỗi khi thực hiện ký số.');
        }
      }
    } else {
      setDisplayCode(Date.now());
    }
  }
  const infoForm = useForm({
    fields: [
      { field: 'agreementNo', header: 'Số hợp đồng', disabled: true, className: 'col-12' },
      { field: 'agreementDate', header: 'Ngày hợp đồng', disabled: true, InputTextProps: { type: 'date' }, className: 'col-12' },
    ]
  })

  const downloadSignTool = () => {
    ToastService.success('Đang bắt đầu tải công cụ ký, vui lòng chờ...');
    window.open(`/iam/tool/Iam_EcontractSetup.zip`);
  }

  const submitCode = () => {
    if (signingSecretCode) {
      setDisplayCode(null)
      signFile()
    } else {
      ToastService.error('Chưa nhập mã bí mật')
    }

  }
  const footer = (
    <div className="align-items-center justify-content-between md:col-12">
      <div className="flex justify-content-between">
        <div>
          <b className={'pt-2'} style={{ color: 'var(--red-500)', fontSize: '20px' }}>Trạng thái: {headerInfo?.status}</b>
        </div>
        <div>
          <div className="flex gap-2">
            <Button label="Tải xuống" severity='info' icon="pi pi-download" className="p-button-sm" onClick={() => {
              const file = activeTabIndex === 0 ? mainFiles[activeMainIndex] : attachmentFiles[activeAttachmentIndex];
              if (file) handleDownload(file);
            }} />
            {headerInfo?.statusId !== 'AGT_SIGN_COMPLETED' && <Button label='Ký hợp đồng' severity='warning' icon="pi pi-pencil" className="p-button-sm" onClick={() => signFile()}></Button>}
            {headerInfo?.statusId !== 'AGT_SIGN_COMPLETED' && <Button
              label='Tải tool ký'
              severity='info'
              icon="pi pi-download"
              onClick={() => downloadSignTool()}
              className="p-button-sm"
            />}
            <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm"
              type="button" onClick={() => setDisplay(false)} />
          </div>
        </div>
      </div>
    </div>
  );
  const codeFooter = (
    <div className="align-items-center justify-content-between md:col-12">
      <div className="flex  flex-row-reverse">
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm"
          type="button" onClick={() => setDisplayCode(false)} />
        <Button label='Xác nhận' severity='success' icon="pi pi-check" onClick={() => submitCode()}></Button>
      </div>
    </div>
  );


  useEffect(() => {
    return () => {
      openedFileIdsRef.current.forEach(fileId => {
        if (agreementId) {
          AgreementService.closeContent(agreementId, fileId).catch(err => {
            console.error('Error closing editor permission:', err)
          })
        }
      })
      openedFileIdsRef.current.clear()
    }
  }, [])

  const handleCloseDialog = () => {
    openedFileIdsRef.current.forEach(fileId => {
      if (agreementId) {
        AgreementService.closeContent(agreementId, fileId).catch(err => {
          console.error('Error closing editor permission:', err)
        })
      }
    })
    openedFileIdsRef.current.clear()
    setDisplay(false)
  }

  const handleDownload = async (file: any) => {
    try {
      const fileId = extractGoogleFileId(file);
      const isGoogleFile = file?.contentLocationTypeEnumId === 'CntLocGoogleDrive' || 
                         file?.contentType === 'application/vnd.google-apps.document' ||
                         (file?.contentLocation && file.contentLocation.includes('docs.google.com'));

      ToastService.success('Đang bắt đầu tải xuống, vui lòng chờ...');
      let blob: Blob | null = null;

      if (fileId) {
        await ensureToken();
        if (!openedFileIdsRef.current.has(fileId)) {
          if (agreementId) {
            await AgreementService.openContent(agreementId, fileId);
            openedFileIdsRef.current.add(fileId);
          }
        }
        blob = await AgreementService.downloadPdf(fileId);
      }

      if (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = file.fileName || 'Tai_lieu.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (err) {
      console.error('Error downloading file:', err);
      ToastService.error('Có lỗi xảy ra khi tải xuống');
    }
  };

  const renderDocumentViewer = (type: 'main' | 'attachment') => {
    const files = type === 'main' ? mainFiles : attachmentFiles;
    const activeIdx = type === 'main' ? activeMainIndex : activeAttachmentIndex;
    const file = files[activeIdx];
    if (!file) {
      return (
        <div className="flex align-items-center justify-content-center h-full text-color-secondary">
          <p>Không tìm thấy file hiển thị.</p>
        </div>
      );
    }

    const fileId = extractGoogleFileId(file);
    const cacheKey = `${type}_${fileId || activeIdx}`;
    const canvases = type === 'main' ? mainFileCanvases[cacheKey] : attachmentFileCanvases[cacheKey];
    const isReady = type === 'main' ? mainFileReady[cacheKey] : attachmentFileReady[cacheKey];

    if (!isReady || (file.contentLocationTypeEnumId === 'CntLocGoogleDrive' && !canvases)) {
      return (
        <div className="flex flex-column align-items-center justify-content-center h-full text-color-secondary gap-3">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
          <p>Đang tải tài liệu...</p>
        </div>
      );
    }

    return (
      <div className="grid grid-nogutter h-full border-round-xl overflow-hidden shadow-2" style={{ backgroundColor: 'var(--surface-card)' }}>
        {/* Left Sidebar - Info */}
        <div className="col-12 lg:col-3 flex flex-column border-right-1 p-3 overflow-auto" style={{ borderColor: 'var(--surface-border)', backgroundColor: 'var(--surface-ground)' }}>
          <h5 className="mt-0 mb-3 flex align-items-center gap-2 font-bold" style={{ color: 'var(--text-color)' }}>
            <i className="pi pi-info-circle text-primary"></i>
            Thông tin tài liệu
          </h5>
          <div className="custom-info-form">
            {infoForm.render()}
          </div>
          {files.length > 1 && (
            <div className="mt-4">
              <h5 className="mb-2 font-bold" style={{ color: 'var(--text-color)' }}>Danh sách file</h5>
              <div className="flex flex-column gap-2">
                {files.map((f, i) => (
                  <Button
                    key={i}
                    label={f.fileName || `File ${i + 1}`}
                    icon="pi pi-file"
                    className={`p-button-sm text-left ${activeIdx === i ? 'p-button-info' : 'p-button-text'}`}
                    onClick={() => {
                      if (type === 'main') setActiveMainIndex(i);
                      else setActiveAttachmentIndex(i);
                      setCurrentPage(1);
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Center - PDF Content */}
        <div className="col-12 lg:col-7 flex flex-column relative" style={{ backgroundColor: 'var(--surface-section)' }}>
          <div className="flex align-items-center justify-content-center p-2 border-bottom-1 text-color-secondary text-xs gap-3" style={{ backgroundColor: 'var(--surface-ground)', borderColor: 'var(--surface-border)' }}>
            <span>Trang: {currentPage} / {canvases?.length || 0}</span>
          </div>
          <ScrollPanel style={{ width: '100%', height: 'calc(100vh - 250px)' }}>
            <div className="flex flex-column align-items-center p-4 min-h-full justify-content-center">
              {canvases && canvases[currentPage - 1] && (
                <div className="shadow-4 bg-white relative">
                  <img
                    src={canvases[currentPage - 1].toDataURL()}
                    alt={`Page ${currentPage}`}
                    style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                  />
                  {/* Signature Overlay */}
                  {type === 'main' && headerInfo?.signatureLocationList?.filter((loc: any) => {
                      const activeFile = mainFiles[activeMainIndex];
                      // Lọc chữ ký theo đúng file đang active (agreementContentId)
                      return (loc.pageNumber === currentPage || loc.page === currentPage) && 
                             (loc.agreementContentId === activeFile?.agreementContentId || !loc.agreementContentId);
                  }).map((loc: any, idx: number) => {
                    const canvas = canvases[currentPage - 1];
                    const pdfWidth = loc.pageWidth || 595; // Default A4
                    const pdfHeight = loc.pageHeight || 842;
                    
                    // Tính toán tọa độ tỉ lệ %
                    const left = (loc.llx / pdfWidth) * 100;
                    const top = (1 - (loc.lly + loc.heightPx) / pdfHeight) * 100;
                    const width = (loc.widthPx / pdfWidth) * 100;
                    const height = (loc.heightPx / pdfHeight) * 100;

                    const isVisualSign = loc.signatureTypeEnumId === 'AgtHandwritingVerified' || loc.signatureTypeEnumId === 'AgtImageVerified';
                    const hasVisualData = visualDataMap[loc.locationSeqId];

                    return (
                      <div 
                        key={idx}
                        className={`absolute border-2 border-dashed ${isVisualSign ? 'border-primary-500 bg-primary-100 cursor-pointer hover:bg-primary-50' : 'border-orange-500 bg-orange-100'} opacity-60 flex flex-column align-items-center justify-content-center overflow-hidden`}
                        style={{
                          left: `${left}%`,
                          top: `${top}%`,
                          width: `${width}%`,
                          height: `${height}%`,
                          zIndex: 10
                        }}
                        onClick={() => {
                            if (isVisualSign) {
                                setSelectingLocationId(loc.locationSeqId);
                                setSelectingExpectedType(loc.signatureTypeEnumId);
                                setDisplaySignatureSelector(true);
                            }
                        }}
                      >
                        {isVisualSign && (hasVisualData || loc.visualData) ? (
                            <img src={visualDataMap[loc.locationSeqId] || loc.visualData} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt="Chữ ký" />
                        ) : (
                            <>
                                <i className="pi pi-image text-primary-600 mb-1" style={{ fontSize: '0.8rem' }}></i>
                                <span className={`${isVisualSign ? 'text-primary-800' : 'text-orange-800'} font-bold`} style={{ fontSize: '0.6rem', textAlign: 'center', lineHeight: '1' }}>
                                   {isVisualSign && !hasVisualData && !loc.visualData ? 'Nhấn để chọn chữ ký' : (loc.name || 'Chờ ký')}
                                </span>
                            </>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </ScrollPanel>
        </div>

        {/* Right Sidebar - Thumbnails */}
        <div className="col-12 lg:col-2 flex flex-column border-left-1 p-2 overflow-auto" style={{ borderColor: 'var(--surface-border)', backgroundColor: 'var(--surface-ground)' }}>
          <h6 className="text-color-secondary text-xs font-bold uppercase mb-3 text-center tracking-wider opacity-60">Các trang</h6>
          <ScrollPanel style={{ height: 'calc(100vh - 250px)' }}>
            <div className="flex flex-column gap-3 p-2">
              {canvases?.map((canvas, i) => (
                <div
                  key={i}
                  className={`cursor-pointer transition-all border-2 border-round overflow-hidden relative ${currentPage === i + 1 ? 'border-primary shadow-2 scale-102' : 'border-transparent opacity-70 hover:opacity-100'}`}
                  style={{ borderColor: currentPage === i + 1 ? 'var(--primary-color)' : 'transparent' }}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  <img
                    src={canvas.toDataURL()}
                    alt={`Thumbnail ${i + 1}`}
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                  />
                  <div className={`absolute bottom-0 right-0 px-2 py-1 text-xs font-bold ${currentPage === i + 1 ? 'bg-primary text-white' : 'bg-gray-200 text-700'} border-round-top-left shadow-2`}>
                    {i + 1}
                  </div>
                </div>
              ))}
            </div>
          </ScrollPanel>
        </div>
      </div>
    );
  };

  return (
    <Dialog header={`Chi tiết hợp đồng`} maximized={true} draggable={false} footer={footer} visible={!!display}
      position="top" onHide={() => setDisplay(false)}
      contentClassName="p-0 overflow-hidden"
    >
      <style>{`
        .custom-info-form .p-inputtext {
          font-size: 0.875rem !important;
        }
        .custom-info-form label {
          font-size: 0.75rem !important;
          margin-bottom: 0.25rem !important;
          display: block;
        }
        .scale-102 { transform: scale(1.02); }
        .thumbnail-item { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
        .thumbnail-item:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
      `}</style>

      {data && (
        <TabView activeIndex={activeTabIndex} onTabChange={(e) => {
          setActiveTabIndex(e.index);
          setCurrentPage(1);
        }} className="h-full">
          <TabPanel header={`File chính (${mainFiles.length})`}>
            {renderDocumentViewer('main')}
          </TabPanel>

          <TabPanel header={`File đính kèm (${attachmentFiles.length})`}>
            {renderDocumentViewer('attachment')}
          </TabPanel>
        </TabView>
      )}
      <Dialog header={`Nhập mã bí mật`} draggable={false} footer={codeFooter} visible={!!displayCode} style={{ width: '30rem', height: '12rem', }} position="center" onHide={() => setDisplayCode(false)}>
        <InputText value={signingSecretCode} onChange={(e) => setSigningSecretCode(e.target.value)} />
      </Dialog>
      
      <SignatureSelectorDialog
        visible={displaySignatureSelector}
        onHide={() => setDisplaySignatureSelector(false)}
        expectedType={selectingExpectedType}
        onSelect={(base64) => {
            if (selectingLocationId) {
                setVisualDataMap(prev => ({ ...prev, [selectingLocationId]: base64 }));
            }
        }}
      />
    </Dialog>
  );
}